export default {
  selectedProductOpen: false,
  selectedProductId: null
}
